import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { getRegistries } from '../../../../actions/website/entities/RegistryActions';

// Components
import WebsitePreview from './WebsitePreview';
import WebsitePreviewPromo from './WebsitePreviewPromo';

/**
 * RegistryPreview
 * 
 * @param {boolean} hasOtherRegistries  - whether user has other registries or no
 * @param {strbooleaning} hasOtherRegistries - whether user has Zola registry or no
 * @param {string} pageType - page type
*/

class RegistryPreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRegistriesReceived: false,
    };

    this.checkRegistriesReceived = this.checkRegistriesReceived.bind(this);
  }

  componentDidMount() {
    const { getRegistryEntities } = this.props;

    getRegistryEntities(this.checkRegistriesReceived);
  }

  checkRegistriesReceived() {
    this.setState({
      isRegistriesReceived: true,
    });
  }

  render() {
    const { hasOtherRegistries, hasZolaRegistry, pageType } = this.props;
    const { isRegistriesReceived } = this.state;
    const hasRegistry = hasOtherRegistries || hasZolaRegistry;
    const showWebsitePreviewPromo = isRegistriesReceived ? !hasRegistry : false;
    const showWebsitePreview = isRegistriesReceived ? hasRegistry : false;

    return  (
      <>
        { showWebsitePreview && <WebsitePreview /> }
        { showWebsitePreviewPromo && <WebsitePreviewPromo pageType={pageType} /> }
      </>
    );
  }
}

RegistryPreview.propTypes = {
  hasZolaRegistry: PropTypes.bool,
  hasOtherRegistries: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  hasZolaRegistry: state.user.userContext.registry_ids.length > 0,
  hasOtherRegistries: state.website.entities.orderedIds.length > 0,
});
  
const mapDispatchToProps = dispatch => ({
  getRegistryEntities: (checkHaseOtherRegisrty) => {
    dispatch(getRegistries()).then(checkHaseOtherRegisrty);
  },
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(RegistryPreview);



// WEBPACK FOOTER //
// ./src/components/manage/website/WebsitePreview/RegistryPreview.jsx